import { Component, OnInit } from '@angular/core';
import { AgileSDKService } from '../services/agile-sdk.service';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-user-guides',
  templateUrl: './user-guides.component.html',
  styleUrls: ['./user-guides.component.css']
})
export class UserGuidesComponent implements OnInit {

  userGuides:string[];
  fileName:string;

  constructor(private aglServ:AgileSDKService) { }

  ngOnInit(): void {
    this.getUserGuides();
  }

  getUserGuides(){
    this.aglServ.getUserGuides().subscribe((data) => {this.userGuides = data})
  }

  downloadFile(){
    this.aglServ.downloadUserGuide(this.fileName).subscribe(
      (data) => {
        saveAs(data, this.fileName);
      }
    )
  }



}
